import { render } from "./Spinner.vue?vue&type=template&id=6c8cae95&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=6c8cae95&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c8cae95"

export default script